import { useState } from 'react';
import { updateMicrositeUrl } from '../../../api/login.service';

export default function MicrositeSettings({
  phoneNumberId,
  savedUrl,
}: {
  phoneNumberId?: string;
  savedUrl?: string;
}) {
  const [siteUrl, setSiteUrl] = useState(savedUrl || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  const url = siteUrl.trim();

  const save = async () => {
    if (!phoneNumberId) {
      setError('Sign in again to save the microsite.');
      return;
    }
    if (!url) {
      setError('Enter the microsite URL.');
      return;
    }
    setSaving(true);
    setError('');
    setSaved(false);
    try {
      const result = await updateMicrositeUrl({ phoneNumberId, micrositeUrl: url });
      if (!result?.success) {
        setError(result?.error || 'Could not save the microsite.');
        return;
      }
      setSaved(true);
    } catch {
      setError('Could not save the microsite. Try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-1">Microsite</h3>
      <label className="block text-sm text-gray-700">
        Microsite URL
        <input
          value={siteUrl}
          onChange={(event) => {
            setSaved(false);
            setSiteUrl(event.target.value);
          }}
          placeholder="https://"
          className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg"
        />
      </label>
      {error ? <p className="mt-3 text-sm text-red-600">{error}</p> : null}
      {saved ? <p className="mt-3 text-sm text-green-700">Saved on this business.</p> : null}
      <button
        type="button"
        onClick={save}
        disabled={saving}
        className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
      >
        {saving ? 'Saving...' : 'Save'}
      </button>
      {url ? (
        <div className="mt-6 mx-auto w-[390px] rounded-[2rem] border-[10px] border-gray-900 bg-gray-900 shadow-xl">
          <iframe title="Microsite preview" src={url} className="h-[700px] w-full rounded-[1.4rem] bg-white" />
        </div>
      ) : null}
    </div>
  );
}
